import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Segment, SegmentType } from '~src/interfaces/segment.interface';
import { routes } from '~src/routingConfig';
import { getNameOfSegment } from '~src/services/getNameOfSegment';
import { Uuid } from '~src/services/uuid';

import AvatarBox from '~src/shared/avatarBox/AvatarBox';
import SvgIcon from '~src/shared/SvgIcon';
import HoverInfoIcon from '~src/shared/tooltips/HoverInfoIcon';

import {
  Amount,
  AvatarContainer,
  Company,
  InformationContainer,
  LeftCol,
  Name,
  OutsideWrapper,
  RightCol,
} from './rowTitle.sc';

interface Props {
  link?: string;
  select: (group: string | null) => void;
  segment: Segment;
  noData: boolean;
  hasAggr: boolean;
  clickable: boolean;
}

const RowTitle: FC<Props> = (props) => {
  const [t] = useTranslation();
  const clickable = useMemo(
    () =>
      props.clickable &&
      props.segment.type === SegmentType.Group &&
      props.segment.user_count !== undefined &&
      !props.noData &&
      (props.segment.user_count > 0 || props.hasAggr),
    [props.segment],
  );

  const selectThisGroup = () => {
    if (clickable) {
      props.select(props.segment.id);
    }
  };

  const segmentName = useMemo(
    () => (
      <span data-translation="x.compare.entities.anonymous.name">
        {getNameOfSegment(t, props.segment, false) || t('x.compare.entities.anonymous.name')}
      </span>
    ),
    [props.segment, t],
  );

  return (
    <OutsideWrapper $clickable={clickable} onClick={selectThisGroup}>
      <AvatarContainer>
        <AvatarBox
          type={props.segment.type}
          name={getNameOfSegment(t, props.segment) || ''}
          url={props.segment.image_url}
          size={35}
        />
      </AvatarContainer>
      <InformationContainer>
        <LeftCol>
          {props.segment.type === SegmentType.User ? (
            <Link to={`${routes.reports.user(Uuid.fromHexString(props.segment.id))}`}>
              <Name>{segmentName}</Name>
            </Link>
          ) : props.segment.type === SegmentType.Company ? (
            <Link to={routes.reports.company}>
              <Company>{segmentName}</Company>
            </Link>
          ) : (
            segmentName
          )}
          {props.segment.user_count !== undefined && props.segment.type === SegmentType.Group && (
            <Amount>
              <SvgIcon name="iconTwoPeople" width={15} />
              <span>{props.segment.user_count}</span>&nbsp;&nbsp;
              <HoverInfoIcon infoText={t('x.compare.user_count_info')} />
            </Amount>
          )}
        </LeftCol>
        {clickable && (
          <RightCol>
            <SvgIcon name="iconArrow" width={15} viewBoxWidth={25} />
          </RightCol>
        )}
      </InformationContainer>
    </OutsideWrapper>
  );
};

export default RowTitle;
